export default "__VITE_ASSET__3dedfbd2__"